import React, { useContext, useCallback } from 'react';
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';

import { LoggedUserContext } from 'contexts';

import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import * as routes from 'routes';
import Axios from 'axios';

const LoginPage = ({ history }) => {
  const { login } = useContext(LoggedUserContext);

  const handleSuccess = useCallback(
    async googleResponse => {
      try {
        console.log('YUUUPIII', googleResponse);
        await login(googleResponse);
        history.replace(routes.PRICING_ROUTE);
      } catch (error) {
        console.error(error);
      }
    },
    [login, history]
  );

  const fetchUserData = useGoogleLogin({
    onSuccess: async tokenObj => {
      const res = await Axios.get(
        `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenObj.access_token}`,
        {
          headers: {
            Authorization: `Bearer ${tokenObj.access_token}`,
            Accept: 'application/json'
          }
        }
      );
      const googleResponse = {
        accessToken: tokenObj.access_token,
        profileObj: {
          email: res.email,
          givenName: res.given_name,
          familyName: res.family_name,
          name: res.name,
          imageUrl: res.picture,
          googleId: res.id
        }
      };
      handleSuccess(googleResponse);
    }
  });

  return (
    <Container>
      <Row className="justify-content-md-center mt-5">
        <Col xs={12} lg={5}>
          <Card>
            <Card.Body>
              <Card.Title>Pluto</Card.Title>
              <Container style={{ position: 'relative', margin: '0', padding: '0' }}>
                <Card
                  onClick={fetchUserData}
                  style={{
                    width: '100%',
                    position: 'absolute',
                    height: '100%',
                    cursor: 'pointer',
                    zIndex: '1',
                    background: 'none',
                    margin: '0',
                    padding: '0'
                  }}
                ></Card>
                <GoogleLogin />
              </Container>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
